/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-reveal/Fade';

import NotFound from 'assets/images/NotFound.png';

import Button from 'elements/Button';

export default function PortfolioDetail({ data }) {
  if (data === null) {
    return (
      <section className="container mx-auto">
        <Fade bottom>
          <div className="flex flex-col w-full justify-center">
            <div className="flex w-full justify-center">
              <img src={NotFound} alt="Not Found" className="sm:w-3/4 xl:w-5/12 mt-5" />
            </div>
            <h1 className="text-theme-blue text-2xl text-center mt-5">
              Project Not Found
            </h1>
            <div className="flex justify-center">
              <Button href="/case-studies" type="link" className="flex w-30 h-10 px-5 mt-5 bg-theme-blue text-white items-center rounded transform transition duration-500 hover:bg-gray-900">
                Go Back
              </Button>
            </div>
          </div>
        </Fade>
      </section>
    );
  }

  return (
    <section className="container mx-auto">
      <Fade bottom>
        <Button type="link" href="/case-studies" className="flex w-40 h-8 text-lg items-center ml-6 sm:ml-20 mt-8 font-light text-gray-400 hover:underline">
          <svg className="w-5 h-5 text-gray-400 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
          View All Case Studies
        </Button>
      </Fade>

      {
                data.map((item) => (
                  <div className="flex flex-col mt-8 justify-center">
                    <Fade bottom>
                      <h1 className="text-5xl text-theme-blue text-center font-bold">{item.title}</h1>

                      <p className="font-light text-xl text-gray-400 text-center mb-10">
                        {item.type}
                      </p>
                    </Fade>

                    <Fade bottom delay={300 * 1}>
                      <div className="flex justify-center xl:mb-6">
                        <img src={`../${item.imageUrl}`} alt="Project" className="flex w-4/5 sm:w-4/6" />
                      </div>
                    </Fade>

                    <Fade bottom delay={300 * 1}>
                      {/* Client & Industry Info */}
                      {(item.client || item.industry) && (
                        <div className="flex flex-col mt-16 mb-12 mx-8 sm:mx-16 xl:mx-28">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                            {item.client && (
                              <div className="bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-xl p-6 border border-theme-purple/20">
                                <h3 className="text-sm font-semibold text-gray-500 mb-2 uppercase tracking-wide">Client</h3>
                                <p className="text-2xl font-bold text-theme-blue">{item.client}</p>
                              </div>
                            )}
                            {item.industry && (
                              <div className="bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-xl p-6 border border-theme-purple/20">
                                <h3 className="text-sm font-semibold text-gray-500 mb-2 uppercase tracking-wide">Industry</h3>
                                <p className="text-2xl font-bold text-theme-blue">{item.industry}</p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Problem Statement */}
                      {item.problem && (
                        <div className="flex flex-col mt-8 mb-12 mx-8 sm:mx-16 xl:mx-28">
                          <div className="flex items-center mb-4">
                            <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                              <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                              </svg>
                            </div>
                            <h1 className="text-3xl text-theme-blue font-bold">
                              The Challenge
                            </h1>
                          </div>
                          <p className="font-light text-lg text-gray-600 leading-relaxed text-justify pl-16">
                            {item.problem}
                          </p>
                        </div>
                      )}

                      {/* Solution */}
                      {item.solution && (
                        <div className="flex flex-col mt-8 mb-12 mx-8 sm:mx-16 xl:mx-28">
                          <div className="flex items-center mb-4">
                            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                              <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                            </div>
                            <h1 className="text-3xl text-theme-blue font-bold">
                              Our Solution
                            </h1>
                          </div>
                          <p className="font-light text-lg text-gray-600 leading-relaxed text-justify pl-16">
                            {item.solution}
                          </p>
                        </div>
                      )}

                      {/* Results */}
                      {item.results && item.results.length > 0 && (
                        <div className="flex flex-col mt-8 mb-12 mx-8 sm:mx-16 xl:mx-28">
                          <div className="flex items-center mb-6">
                            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                              <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                              </svg>
                            </div>
                            <h1 className="text-3xl text-theme-blue font-bold">
                              Results & Impact
                            </h1>
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pl-16">
                            {item.results.map((result) => (
                              <div key={result} className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300">
                                <div className="flex items-start">
                                  <div className="flex-shrink-0 w-6 h-6 bg-theme-purple/10 rounded-full flex items-center justify-center mr-3 mt-1">
                                    <svg className="w-4 h-4 text-theme-purple" fill="currentColor" viewBox="0 0 20 20">
                                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                  </div>
                                  <p className="font-medium text-gray-700 leading-relaxed">{result}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Technologies Used */}
                      {item.technologies && item.technologies.length > 0 && (
                        <div className="flex flex-col mt-8 mb-12 mx-8 sm:mx-16 xl:mx-28">
                          <div className="flex items-center mb-5">
                            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                              <svg className="w-6 h-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                              </svg>
                            </div>
                            <h1 className="text-3xl text-theme-blue font-bold">
                              Technologies Used
                            </h1>
                          </div>
                          <div className="flex flex-wrap gap-3 pl-16">
                            {item.technologies.map((tech) => (
                              <span key={tech} className="px-4 py-2 bg-gradient-to-r from-theme-purple/10 to-dark-theme-purple/10 text-theme-purple border border-theme-purple/30 rounded-lg font-medium text-sm shadow-sm hover:shadow-md transition-shadow duration-300">
                                {tech}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Project Responsibilities */}
                      <div className="flex flex-col mx-8 sm:mx-16 xl:mx-28 mt-8 mb-12">
                        <h1 className="text-3xl text-theme-blue font-bold mb-5">
                          Project Responsibilities
                        </h1>
                        <div className="flex flex-wrap gap-3">
                          {
                            item.responsibility.map((responsibility) => (
                              <div key={responsibility} className="px-6 py-3 text-theme-purple border border-theme-purple rounded-full shadow-lg bg-white hover:bg-theme-purple hover:text-white transition-colors duration-300">
                                {responsibility}
                              </div>
                            ))
                          }
                        </div>
                      </div>

                      <p className="font-light italic text-gray-400 mt-16 mx-8 sm:mx-16 xl:mx-28">
                        Project developed by ERapid Technologies.
                        {' '}
                        <br />
                        {item.credit && (
                          <>
                            Learn more:
                            {' '}
                            <Button type="link" href={item.credit} target="_blank" className="text-theme-purple" isExternal>{item.credit}</Button>
                          </>
                        )}
                      </p>
                    </Fade>
                  </div>
                ))
            }
    </section>
  );
}
